import { Component, Vue, Prop, Watch, Ref } from 'vue-property-decorator';
import { Camera } from '@/models/camera';
import { Photo } from '@/models/photo';
import { TimelapseConfiguration } from '@/models/timelapseconfiguration';
import { State } from 'vuex-class';
import VueSlider from 'vue-slider-component';
import VueTimepicker from 'vue2-timepicker/src/vue-timepicker.vue';
import { subDays, differenceInDays, eachDayOfInterval, startOfDay, endOfDay, parse, isBefore } from 'date-fns';
// @ts-ignore no d.ts
import Datepicker from 'vuejs-datepicker';
// @ts-ignore no d.ts
import { en, fr } from 'vuejs-datepicker/dist/locale';
// @ts-ignore no d.ts
import VirtualCollection from 'vue-virtual-collection';
import S3Image from '../s3-image/S3Image.vue';
import { Logger } from 'aws-amplify';
const logger = new Logger('TimelapseFilter');

interface Period {
  begin: {
    HH?: string;
    mm?: string;
  };
  end: {
    HH?: string;
    mm?: string;
  };
}

@Component({
  components: {
    VueSlider,
    VueTimepicker,
    S3Image,
    Datepicker,
  },
})
export default class TimelapseFilter extends Vue {
  /*
      private get computedModel(): TimelapseConfiguration {
        return Object.assign({}, this.model);
      }
      */
  @Prop({ type: Number, default: 0 }) private datebegin!: number;
  @Prop({ type: Number, default: 0 }) private dateend!: number;
  @Prop({ type: Boolean, default: true }) readonly showLastDiv!: boolean;

  public get datepickerLocal(): unknown {
    return this.locale === 'en' ? en : fr;
  }

  private get minSliderDate(): number {
    return this.allPhotosDates.length > 0 ? this.allPhotosDates[0] : 0;
  }

  private get maxSliderDate(): number {
    return this.allPhotosDates.length > 0 ? this.allPhotosDates[this.allPhotosDates.length - 1] : 1;
  }

  private get allPhotosDates(): number[] {
    logger.info('refresh allPhotosDates');
    if (this.withinInterval && this.imagesKey.length > 0) {
      return eachDayOfInterval({
        start: this.imagesKey[0].createdAt,
        end: this.imagesKey[this.imagesKey.length - 1].createdAt,
      }).map((date) => date.getTime() / 1000);
    } else {
      return [];
    }
  }

  public get dateFormat(): string {
    return this.locale === 'en' ? 'MM/DD/YY' : 'DD/MM/YY';
  }

  public get duree(): string {
    if (this.withinInterval) {
      const date = new Date(0);
      date.setSeconds(this.dataImagesKey.length / this.model.fps);
      return date.toISOString().substr(11, 8);
    } else {
      return '';
    }
  }

  private toDate(ts?: number): Date | null {
    return typeof ts === 'number' && !isNaN(ts) ? new Date(ts * 1000) : null;
  }

  // Fenêtre autorisée pour le datepicker (désactive tout avant le 1er jour et après le dernier)
  public get disabledDates(): { to?: Date; from?: Date } {
    const dates = this.allPhotosDates;
    if (!dates.length) return {};
    const first = new Date(dates[0] * 1000);
    const last = new Date(dates[dates.length - 1] * 1000);
    // vuejs-datepicker : 'to' désactive <= date, 'from' désactive >= date
    return {
      to: new Date(first.getFullYear(), first.getMonth(), first.getDate() - 1),
      from: new Date(last.getFullYear(), last.getMonth(), last.getDate() + 1),
    };
  }

  // Valeurs Date “propres” pour l’UI du slider de dates
  public get beginDateObj(): Date | null {
    return this.toDate(this.localSliderDates[0]);
  }
  public get endDateObj(): Date | null {
    return this.toDate(this.localSliderDates[1]);
  }

  public onStartDateSelected(date: Date): void {
    const timestamp = Math.floor(date.getTime() / 1000);
    this.$set(this.sliderDates, 0, timestamp);
    this.model.interval.begin = new Date(timestamp * 1000).getTime() / 1000;
    this.$nextTick(() => {
      this.updateSlider();
    });
  }

  public onEndDateSelected(date: Date): void {
    const timestamp = Math.floor(date.getTime() / 1000);
    this.$set(this.sliderDates, 1, timestamp); // Utilisez $set pour mettre à jour réactivement la valeur
    this.model.interval.end = endOfDay(new Date(timestamp * 1000)).getTime() / 1000;

    this.$nextTick(() => {
      this.updateSlider(); // Mettez à jour le slider après la mise à jour des dates
    });
  }

  public onStartDateSelected1(date: Date): void {
    const timestamp = Math.floor(date.getTime() / 1000);
    const datebegin = new Date(timestamp * 1000).getTime();
    console.log('configbegin', datebegin);
    this.$emit('start-date-selected', datebegin);
    this.$nextTick(() => {
      this.updateSlider(); // Mettez à jour le slider après la mise à jour des dates
    });
  }

  public onEndDateSelected1(date: Date): void {
    const timestamp = Math.floor(date.getTime() / 1000);
    const dateend = new Date(timestamp * 1000).getTime();
    console.log('configend', dateend);
    this.$emit('end-date-selected', dateend);
  }

  public resetFilters(): void {
    // Si des dates sont disponibles, on les réinitialise aux valeurs maximales
    if (this.allPhotosDates.length > 0) {
      const firstPhotoDate = this.allPhotosDates[0];
      const lastPhotoDate = this.allPhotosDates[this.allPhotosDates.length - 1];

      // Met à jour le slider avec les valeurs maximales
      this.sliderDates = [firstPhotoDate, lastPhotoDate];

      // Mise à jour du modèle
      this.model.interval.begin = startOfDay(firstPhotoDate * 1000).getTime() / 1000;
      this.model.interval.end = endOfDay(lastPhotoDate * 1000).getTime() / 1000;

      this.model.days = [0, 1, 2, 3, 4, 5, 6];

      // Réinitialise la période principale (de 00:00 à 23:59)
      this.model.period = {
        startHour: '00:00',
        endHour: '23:59',
      };

      // Réinitialise la période exclue (vide ou une plage par défaut)
      this.model.exclude = undefined;

      // Met à jour les champs visuels des périodes (liés aux sliders et time pickers)
      this.period.begin = { HH: '00', mm: '00' };
      this.period.end = { HH: '23', mm: '59' };
      this.except.begin = { HH: '', mm: '' };
      this.except.end = { HH: '', mm: '' };

      // Mise à jour du slider
      this.updateSlider();
    }
  }

  private updateSlider(): void {
    this.localSliderDates = [...this.sliderDates];
  }

  private formatDate(timestamp: number | undefined): string {
    if (timestamp && !isNaN(timestamp)) {
      const date = new Date(timestamp * 1000);
      return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
    } else {
      return '-/-/-';
    }
  }

  @Ref('scroller') readonly scroller!: VirtualCollection;
  @Ref('photos') readonly photos!: HTMLDivElement;

  @Prop({ required: true, type: Object }) readonly camera!: Camera;
  @Prop({ type: Boolean, default: true }) readonly withinInterval!: boolean;
  @Prop({ required: true, type: Object }) readonly value!: TimelapseConfiguration;
  @Prop() readonly imagesKey!: Photo[];
  @Prop() readonly dataImagesKey!: Photo[];
  @Prop({ required: true }) readonly isPremium!: boolean;

  @State('locale', { namespace: 'profile' }) private locale!: string;
  @State('isLoading', { namespace: 'photo' }) readonly loadingPhoto!: boolean;
  @State('loadingTimelapse', { namespace: 'project' }) readonly loadingTimelapse!: boolean;

  // private model: TimelapseConfiguration = { ...this.value };
  private get model(): TimelapseConfiguration {
    return this.value;
  }

  private set model(val: TimelapseConfiguration) {
    const compare = JSON.stringify(val).localeCompare(JSON.stringify(this.value));
    if (compare !== 0) {
      this.$emit('input', val);
    }
  }

  private visible = true;

  private sliderDates: number[] = [];
  private lastNDaysDate = NaN;
  private period: Period = { begin: { HH: '00', mm: '00' }, end: { HH: '23', mm: '59' } };
  private periodError: boolean | null = null;
  private except: Period = { begin: { HH: '', mm: '' }, end: { HH: '', mm: '' } };
  private exceptError: boolean | null = null;
  private exposureRange: { min: number; max: number } = { min: Infinity, max: -Infinity };
  private localSliderDates: number[] = [];
  private localLastNDaysDate = NaN;

  private dataReady = false;

  private onLastNDaySliderInput(value: number): void {
    this.localLastNDaysDate = value;
  }

  private onLastNDaySliderDragEnd(): void {
    this.lastNDaysDate = this.localLastNDaysDate;
    this.model.lastNDaysSpan = differenceInDays(
      this.allPhotosDates[this.allPhotosDates.length - 1] * 1000,
      this.lastNDaysDate * 1000
    );
    this.updateLastNDaysDate(this.model.lastNDaysSpan);
  }

  public mounted(): void {
    logger.info('mounted', { model: this.model });
    if (!this.loadingPhoto && !this.loadingTimelapse) {
      this.onDataReady();
    }
  }

  public datepickerSelectedBegin(date: Date): void {
    this.model.interval.begin = startOfDay(date).getTime() / 1000;
  }

  public datepickerSelectedEnd(date: Date): void {
    this.model.interval.end = endOfDay(date).getTime() / 1000;
  }

  /*
      @Watch('computedModel', { deep: true })
      public onModelChange(val: TimelapseConfiguration, oldVal: TimelapseConfiguration): void {
        const compare = JSON.stringify(val).localeCompare(JSON.stringify(oldVal));
        if (compare !== 0) {
          this.$emit('input', val);
        }
      }
      */

  /*
      @Watch('value', { deep: true })
      public onValueChange(val: TimelapseConfiguration): void {
        this.model = { ...val };
      }
      */

  @Watch('period', { deep: true })
  public onPeriodChange(val: Period): void {
    logger.info('onPeriodChange', JSON.stringify(val));
    if (this.period.begin.HH === undefined || this.period.begin.HH === '') {
      this.period.begin.HH = '00';
      this.period.begin.mm = '00';
    }
    if (this.period.end.HH === undefined || this.period.end.HH === '') {
      this.period.end.HH = '23';
      this.period.end.mm = '59';
    }

    const startHourStr = this.period.begin.HH + ':' + this.period.begin.mm;
    const endHourStr = this.period.end.HH + ':' + this.period.end.mm;

    const startHour = parse(startHourStr, 'HH:mm', new Date());
    const endHour = parse(endHourStr, 'HH:mm', new Date());
    if (isBefore(startHour, endHour)) {
      this.model.period.startHour = startHourStr;
      this.model.period.endHour = endHourStr;
      this.periodError = null;
    } else {
      this.periodError = true;
    }
  }

  @Watch('except', { deep: true })
  public onExceptChange(val: Period): void {
    logger.info('onExceptChange', JSON.stringify(val));
    if (val.begin.HH !== '' && val.begin.mm === '') {
      this.except.begin.mm = '00';
    }
    if (val.end.HH !== '' && val.end.mm === '') {
      this.except.end.mm = '00';
    }
    if (val.begin.HH === undefined || val.begin.HH === '' || val.end.HH === undefined || val.end.HH === '') {
      this.model.exclude = undefined;
    } else {
      const startHourStr = this.except.begin.HH + ':' + this.except.begin.mm;
      const endHourStr = this.except.end.HH + ':' + this.except.end.mm;

      const startHour = parse(startHourStr, 'HH:mm', new Date());
      const endHour = parse(endHourStr, 'HH:mm', new Date());
      if (isBefore(startHour, endHour)) {
        this.model.exclude = [
          {
            startHour: startHourStr,
            endHour: endHourStr,
          },
        ];
        this.exceptError = null;
      } else {
        this.exceptError = true;
      }
    }
  }

  @Watch('loadingTimelapse')
  public onLoadingTimelapse(val: boolean, oldVal: boolean): void {
    logger.info('loadingTimelapse', { val, oldVal, loadingPhoto: this.loadingPhoto });
    if (oldVal && !val && !this.loadingPhoto) {
      this.onDataReady();
    }
  }

  @Watch('loadingPhoto')
  public onLoadingPhoto(val: boolean, oldVal: boolean): void {
    logger.info('loadingPhoto', { val, oldVal, loadingTimelapse: this.loadingTimelapse });
    if (oldVal && !val && !this.loadingTimelapse) {
      this.onDataReady();
    }
  }

  public onDataReady(): void {
    logger.info('onDataReady', { model: this.model });

    if (this.allPhotosDates.length === 0) {
      this.dataReady = true;
      return;
    }

    const firstPhotoDate = this.allPhotosDates[0];
    const lastPhotoDate = this.allPhotosDates[this.allPhotosDates.length - 1];

    // Si le modèle est vide ou incorrect, on l'initialise
    if (!this.model.interval || isNaN(this.model.interval.begin) || isNaN(this.model.interval.end)) {
      this.model.interval = {
        begin: startOfDay(new Date(firstPhotoDate * 1000)).getTime() / 1000,
        end: endOfDay(new Date(lastPhotoDate * 1000)).getTime() / 1000,
      };
    }

    if (!Array.isArray(this.model.days) || this.model.days.length === 0) {
      this.model.days = [0, 1, 2, 3, 4, 5, 6];
    }

    // Configuration du slider
    if (!this.model.lastNDays) {
      const snapToExisting = (t: number) => {
        const i = this.allPhotosDates.findIndex((d) => d === t);
        if (i !== -1) return t;
        // sinon, prends le jour le plus proche
        let closest = this.allPhotosDates[0];
        let minDiff = Math.abs(t - closest);
        for (const d of this.allPhotosDates) {
          const diff = Math.abs(t - d);
          if (diff < minDiff) {
            minDiff = diff;
            closest = d;
          }
        }
        return closest;
      };

      const begin = snapToExisting(Math.max(this.model.interval.begin, firstPhotoDate));
      const end = snapToExisting(Math.min(this.model.interval.end, lastPhotoDate));

      this.sliderDates = [Math.min(begin, end), Math.max(begin, end)];
      this.localSliderDates = [...this.sliderDates];
    } else {
      this.updateLastNDaysDate(this.model.lastNDaysSpan);
      this.localLastNDaysDate = this.lastNDaysDate;
    }

    // Mise à jour de la période principale
    const startPeriod = this.model.period?.startHour?.split(':') || ['00', '00'];
    this.period.begin.HH = startPeriod[0];
    this.period.begin.mm = startPeriod[1];

    const endPeriod = this.model.period?.endHour?.split(':') || ['23', '59'];
    this.period.end.HH = endPeriod[0];
    this.period.end.mm = endPeriod[1];

    // Exclusion si existante
    if (this.model.exclude && this.model.exclude?.length > 0) {
      const excludeStart = this.model.exclude[0].startHour.split(':');
      const excludeEnd = this.model.exclude[0].endHour.split(':');
      this.except.begin.HH = excludeStart[0];
      this.except.begin.mm = excludeStart[1];
      this.except.end.HH = excludeEnd[0];
      this.except.end.mm = excludeEnd[1];
    } else {
      this.except.begin = { HH: '', mm: '' };
      this.except.end = { HH: '', mm: '' };
    }

    this.dataReady = true;
  }

  private commitSliderDates(values: number[]): void {
    if (values.length !== 2) return;
    const [begin, end] = values;
    this.sliderDates = [begin, end];
    this.model.interval.begin = startOfDay(begin * 1000).getTime() / 1000;
    this.model.interval.end = endOfDay(end * 1000).getTime() / 1000;
    this.$emit('input', { ...this.model });
  }

  public onLastNDaysChange(value: boolean): void {
    logger.info('onLastNDaysChange', { value });
    this.model.lastNDays = value;
  }

  public onLastNDaySliderChange(value: number): void {
    this.lastNDaysDate = value;
    this.model.lastNDaysSpan = differenceInDays(
      this.allPhotosDates[this.allPhotosDates.length - 1] * 1000,
      value * 1000
    );
    this.updateLastNDaysDate(this.model.lastNDaysSpan);
  }

  public onLastNDaySpanChange(value: string): void {
    const days = parseInt(value, 10);
    if (isNaN(days)) return;
    this.model.lastNDaysSpan = days;

    const firstPhotoDate = this.allPhotosDates[0];
    const lastPhotoDate = this.allPhotosDates[this.allPhotosDates.length - 1] || new Date().getTime() / 1000;

    const nDaysAgo = Math.floor(subDays(lastPhotoDate * 1000, days).getTime() / 1000);
    const newDate = firstPhotoDate === undefined || nDaysAgo > firstPhotoDate ? nDaysAgo : firstPhotoDate;

    this.lastNDaysDate = newDate;
    this.localLastNDaysDate = newDate;

    this.model.interval.begin = startOfDay(this.lastNDaysDate * 1000).getTime() / 1000;
    this.model.interval.end = endOfDay(lastPhotoDate * 1000).getTime() / 1000;
  }

  private sliderLastNDays(dotsPos: number[]): number[][] {
    return [[dotsPos[0], 100]];
  }

  private updateLastNDaysDate(days: number): void {
    const firstPhotoDate = this.allPhotosDates[0];
    const lastPhotoDate = this.allPhotosDates[this.allPhotosDates.length - 1] || new Date().getTime() / 1000;
    const nDaysAgo = Math.floor(subDays(lastPhotoDate * 1000, days).getTime() / 1000);
    this.lastNDaysDate = firstPhotoDate === undefined || nDaysAgo > firstPhotoDate ? nDaysAgo : firstPhotoDate;
    this.model.interval.begin = startOfDay(this.lastNDaysDate * 1000).getTime() / 1000;
    this.model.interval.end = endOfDay(lastPhotoDate * 1000).getTime() / 1000;
  }

  private formatSliderTooltip(val: number): string {
    if (!val || isNaN(val)) return '-/-/-';
    const d = new Date(val * 1000);
    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const yy = String(d.getFullYear());
    // Même logique que ton this.dateFormat (MM/DD/YY vs DD/MM/YY)
    return this.locale === 'en' ? `${mm}/${dd}/${yy}` : `${dd}/${mm}/${yy}`;
  }
}
